import { match } from 'ts-pattern';

import type { RecordingLength } from '../model/audio-recording.types';

export function calculateRecordingLength(
    elapsedTime: number,
    shortLengthThreshold: number | undefined,
    longLengthThreshold: number | undefined,
): RecordingLength {
    return match<number, RecordingLength>(elapsedTime)
        .when(
            (elapsedTime) => elapsedTime < (shortLengthThreshold ?? -Infinity),
            () => 'too-short',
        )
        .when(
            (elapsedTime) => elapsedTime >= (longLengthThreshold ?? Infinity),
            () => 'too-long',
        )
        .otherwise(() => 'normal');
}
